/* Clickable inspection checklists per vehicle type. Labels in nl/en/ar. */
const L = (nl, en, ar) => ({ nl, en, ar });

const TYRES_CAR = [
  ["tyre_fl", L("Band linksvoor", "Tyre front-left", "إطار أمامي يسار")],
  ["tyre_fr", L("Band rechtsvoor", "Tyre front-right", "إطار أمامي يمين")],
  ["tyre_rl", L("Band linksachter", "Tyre rear-left", "إطار خلفي يسار")],
  ["tyre_rr", L("Band rechtsachter", "Tyre rear-right", "إطار خلفي يمين")],
  ["tyre_pressure", L("Bandenspanning", "Tyre pressure", "ضغط الإطارات")],
  ["tyre_spare", L("Reservewiel / kit", "Spare wheel / kit", "الإطار الاحتياطي")],
];
const axles = (n) => {
  const out = [];
  for (let a = 1; a <= n; a++) {
    out.push([`tyre_a${a}_l`, L(`Band as ${a} links`, `Tyre axle ${a} left`, `إطار محور ${a} يسار`)]);
    out.push([`tyre_a${a}_r`, L(`Band as ${a} rechts`, `Tyre axle ${a} right`, `إطار محور ${a} يمين`)]);
  }
  out.push(["tyre_pressure", L("Bandenspanning", "Tyre pressure", "ضغط الإطارات")]);
  return out;
};
const LIGHTS = [
  ["light_head", L("Koplampen", "Headlights", "المصابيح الأمامية")],
  ["light_rear", L("Achterlichten", "Rear lights", "المصابيح الخلفية")],
  ["light_brake", L("Remlichten", "Brake lights", "أضواء الفرامل")],
  ["light_turn", L("Knipperlichten", "Indicators", "الغمازات")],
  ["light_plate", L("Kentekenverlichting", "Plate light", "إضاءة اللوحة")],
];

/* Onderhoudsbeurt: vaste werkzaamheden per voertuigtype (zelfde keys als backend/pdf_workcard.py SERVICE). */
export const SERVICE = {
  car: [
    ["svc_oil", L("Motorolie verversen", "Replace engine oil", "تغيير زيت المحرك")],
    ["svc_oil_filter", L("Oliefilter vervangen", "Replace oil filter", "تغيير فلتر الزيت")],
    ["svc_fuel_filter", L("Brandstoffilter vervangen", "Replace fuel filter", "تغيير فلتر الوقود")],
    ["svc_air_filter", L("Luchtfilter vervangen", "Replace air filter", "تغيير فلتر الهواء")],
    ["svc_cabin_filter", L("Interieurfilter vervangen", "Replace cabin filter", "تغيير فلتر المكيف")],
    ["svc_fluids", L("Vloeistoffen controleren en bijvullen", "Check and top up fluids", "فحص السوائل وتعبئتها")],
    ["svc_gearbox", L("Versnellingsbakoliepeil controleren", "Check gearbox oil level", "فحص مستوى زيت القير")],
    ["svc_diag", L("Storingsgeheugen uitlezen en fouten wissen", "Read fault memory and clear codes", "قراءة الأعطال ومسحها")],
    ["svc_battery", L("Accu controleren", "Check battery", "فحص البطارية")],
    ["svc_brakes", L("Remmen controleren", "Check brakes", "فحص الفرامل")],
    ["svc_tyres", L("Banden en bandenspanning controleren", "Check tyres and pressure", "فحص الإطارات والضغط")],
    ["svc_reset", L("Service-interval resetten", "Reset service interval", "إعادة ضبط فترة الصيانة")],
    ["svc_testdrive", L("Proefrit maken", "Test drive", "تجربة القيادة")],
  ],
  truck: [
    ["svc_oil", L("Motorolie verversen", "Replace engine oil", "تغيير زيت المحرك")],
    ["svc_oil_filter", L("Oliefilter vervangen", "Replace oil filter", "تغيير فلتر الزيت")],
    ["svc_fuel_filter", L("Brandstoffilters vervangen", "Replace fuel filters", "تغيير فلاتر الوقود")],
    ["svc_adblue_filter", L("AdBlue-filter vervangen", "Replace AdBlue filter", "تغيير فلتر AdBlue")],
    ["svc_air_filter", L("Luchtfilter vervangen", "Replace air filter", "تغيير فلتر الهواء")],
    ["svc_cabin_filter", L("Interieurfilter vervangen", "Replace cabin filter", "تغيير فلتر المكيف")],
    ["svc_steering_filter", L("Stuurfilter vervangen", "Replace steering filter", "تغيير فلتر الدركسيون")],
    ["svc_air_dryer", L("Luchtdrogerpatroon vervangen", "Replace air dryer cartridge", "تغيير خرطوشة مجفف الهواء")],
    ["svc_fluids", L("Vloeistoffen controleren en bijvullen", "Check and top up fluids", "فحص السوائل وتعبئتها")],
    ["svc_driveline_oil", L("Cardan- en versnellingsbakoliepeil controleren", "Check driveline and gearbox oil level", "فحص زيت الكردان والقير")],
    ["svc_diag", L("Storingsgeheugen uitlezen en fouten wissen", "Read fault memory and clear codes", "قراءة الأعطال ومسحها")],
    ["svc_grease", L("Koppelschotel en fusees doorsmeren", "Grease fifth wheel and king pins", "تشحيم صحن القطر والمفاصل")],
    ["svc_battery", L("Accu's controleren en bijvullen", "Check and top up batteries", "فحص البطاريات وتعبئتها")],
    ["svc_brakes", L("Remmen controleren", "Check brakes", "فحص الفرامل")],
    ["svc_reset", L("Service-interval resetten", "Reset service interval", "إعادة ضبط فترة الصيانة")],
    ["svc_testdrive", L("Proefrit maken", "Test drive", "تجربة القيادة")],
  ],
  trailer: [
    ["svc_brakes", L("Remmen controleren en afstellen", "Check and adjust brakes", "فحص الفرامل وضبطها")],
    ["svc_air_dryer", L("Luchtleidingen en koppelingen controleren", "Check air lines and couplings", "فحص خطوط الهواء")],
    ["svc_grease", L("Smeerpunten doorsmeren", "Grease all points", "تشحيم نقاط التشحيم")],
    ["svc_tyres", L("Banden en bandenspanning controleren", "Check tyres and pressure", "فحص الإطارات والضغط")],
    ["svc_lights", L("Verlichting en reflectoren controleren", "Check lights and reflectors", "فحص الإضاءة والعواكس")],
    ["svc_bearings", L("Wiellagers controleren", "Check wheel bearings", "فحص رمان البلي")],
  ],
};

export const INSPECTION = {
  car: [
    { key: "tyres", label: L("Banden", "Tyres", "الإطارات"), items: TYRES_CAR },
    { key: "brakes", label: L("Remmen", "Brakes", "الفرامل"), items: [
      ["brake_pads_f", L("Remblokken voor", "Front pads", "فحمات أمامية")],
      ["brake_pads_r", L("Remblokken achter", "Rear pads", "فحمات خلفية")],
      ["brake_disc_f", L("Remschijven voor", "Front discs", "أقراص أمامية")],
      ["brake_disc_r", L("Remschijven achter", "Rear discs", "أقراص خلفية")],
      ["brake_fluid", L("Remvloeistof", "Brake fluid", "زيت الفرامل")],
      ["brake_hand", L("Handrem", "Handbrake", "فرامل اليد")],
    ] },
    { key: "lights", label: L("Verlichting", "Lights", "الإضاءة"), items: LIGHTS },
    { key: "fluids", label: L("Vloeistoffen", "Fluids", "السوائل"), items: [
      ["oil", L("Motorolie", "Engine oil", "زيت المحرك")],
      ["coolant", L("Koelvloeistof", "Coolant", "سائل التبريد")],
      ["washer", L("Ruitensproeier", "Washer fluid", "ماء المساحات")],
      ["steering_fluid", L("Stuurbekrachtiging", "Power steering", "زيت الدركسيون")],
      ["gearbox_oil", L("Versnellingsbakolie", "Gearbox oil", "زيت القير")],
    ] },
    { key: "chassis", label: L("Onderstel", "Chassis", "الهيكل"), items: [
      ["shocks", L("Schokdempers", "Shock absorbers", "المساعدات")],
      ["ball_joints", L("Fuseekogels / draagarmen", "Ball joints / arms", "المفاصل / الأذرع")],
      ["steering", L("Stuurhuis / stangen", "Steering", "الدركسيون")],
      ["exhaust", L("Uitlaat", "Exhaust", "الشكمان")],
      ["cv_boots", L("Aandrijfashoezen", "CV boots", "جلد العكوس")],
    ] },
    { key: "engine", label: L("Motor / elektrisch", "Engine / electrical", "المحرك / الكهرباء"), items: [
      ["battery", L("Accu", "Battery", "البطارية")],
      ["belt", L("Riemen", "Belts", "السيور")],
      ["obd", L("Foutcodes (OBD)", "Fault codes (OBD)", "أكواد الأعطال")],
      ["air_filter", L("Luchtfilter", "Air filter", "فلتر الهواء")],
      ["cabin_filter", L("Interieurfilter", "Cabin filter", "فلتر المكيف")],
      ["engine_leaks", L("Lekkages motor / bak", "Engine / gearbox leaks", "تسريبات المحرك")],
    ] },
    { key: "visibility", label: L("Zicht & ruiten", "Visibility & glass", "الرؤية والزجاج"), items: [
      ["wipers", L("Ruitenwissers", "Wipers", "المساحات")],
      ["washer_jets", L("Sproeiers", "Washer jets", "رشاشات الماء")],
      ["windscreen", L("Voorruit (sterretje / barst)", "Windscreen (chip / crack)", "الزجاج الأمامي")],
      ["mirrors_glass", L("Spiegels / zijruiten", "Mirrors / side glass", "المرايا / الزجاج الجانبي")],
      ["headlight_aim", L("Koplampafstelling", "Headlight aim", "ضبط المصابيح")],
    ] },
    { key: "body", label: L("Carrosserie", "Body", "الهيكل الخارجي"), items: [
      ["body_damage", L("Lak / deuken / schade", "Paint / dents / damage", "الطلاء / الأضرار")],
      ["bumpers", L("Bumpers", "Bumpers", "الصدامات")],
      ["rust", L("Roest / corrosie", "Rust / corrosion", "الصدأ")],
      ["doors_locks", L("Deuren / sloten / centrale vergrendeling", "Doors / locks / central locking", "الأبواب / الأقفال")],
      ["underbody", L("Bodemplaat / onderkant", "Underbody", "أسفل السيارة")],
    ] },
    { key: "comfort", label: L("Comfort & elektrisch", "Comfort & electrics", "الراحة والكهرباء"), items: [
      ["ac", L("Airco (koeling / geur)", "A/C (cooling / smell)", "المكيف")],
      ["heating", L("Verwarming / ventilatie", "Heating / ventilation", "التدفئة / التهوية")],
      ["windows_el", L("Elektrische ramen", "Power windows", "النوافذ الكهربائية")],
      ["dash_warnings", L("Waarschuwingslampjes dashboard", "Dashboard warning lights", "لمبات التحذير")],
      ["horn", L("Claxon", "Horn", "البوري")],
      ["radio_nav", L("Radio / navigatie / camera", "Radio / navigation / camera", "الراديو / الملاحة")],
    ] },
    { key: "interior", label: L("Interieur", "Interior", "الداخلية"), items: [
      ["seatbelts", L("Gordels", "Seat belts", "أحزمة الأمان")],
      ["seats", L("Stoelen / verstelling", "Seats / adjustment", "المقاعد")],
      ["interior_cond", L("Bekleding / vloer / vocht", "Upholstery / floor / damp", "الفرش / الأرضية")],
      ["airbag_light", L("Airbag-lampje", "Airbag light", "لمبة الوسادة الهوائية")],
    ] },
    { key: "safety", label: L("Veiligheid & keuring", "Safety & inspection", "السلامة والفحص"), items: [
      ["triangle_vest", L("Gevarendriehoek / veiligheidsvest", "Warning triangle / vest", "مثلث التحذير / السترة")],
      ["first_aid", L("Verbandkist / brandblusser", "First-aid kit / extinguisher", "حقيبة الإسعاف / الطفاية")],
      ["jack_tools", L("Krik / wielsleutel", "Jack / wheel brace", "الرافعة / مفتاح العجلات")],
      ["emissions", L("Uitstoot / roet (visueel)", "Emissions / smoke (visual)", "العادم / الدخان")],
      ["inspection_due", L("Keuring / APK vervaldatum", "Inspection due date", "تاريخ الفحص الدوري")],
    ] },
  ],
  truck: [
    { key: "tyres", label: L("Banden per as", "Tyres per axle", "الإطارات لكل محور"), items: axles(3) },
    { key: "brakes", label: L("Remmen", "Brakes", "الفرامل"), items: [
      ["brake_lining", L("Remvoering / blokken", "Brake lining / pads", "فحمات الفرامل")],
      ["brake_discs", L("Remschijven / trommels", "Discs / drums", "الأقراص / الطنابر")],
      ["air_system", L("Luchtdruksysteem / lekkage", "Air system / leaks", "نظام الهواء / تسريب")],
      ["brake_chambers", L("Remcilinders", "Brake chambers", "أسطوانات الفرامل")],
      ["retarder", L("Retarder / motorrem", "Retarder", "فرامل المحرك")],
      ["ebs", L("EBS / ABS", "EBS / ABS", "EBS / ABS")],
    ] },
    { key: "lights", label: L("Verlichting", "Lights", "الإضاءة"), items: [...LIGHTS, ["light_marker", L("Zijmarkering", "Side markers", "الإضاءة الجانبية")]] },
    { key: "fluids", label: L("Vloeistoffen", "Fluids", "السوائل"), items: [
      ["oil", L("Motorolie", "Engine oil", "زيت المحرك")],
      ["coolant", L("Koelvloeistof", "Coolant", "سائل التبريد")],
      ["adblue", L("AdBlue", "AdBlue", "AdBlue")],
      ["hydraulic", L("Hydrauliek", "Hydraulics", "الهيدروليك")],
      ["gearbox_oil", L("Versnellingsbakolie", "Gearbox oil", "زيت القير")],
      ["diff_oil", L("Differentieelolie", "Differential oil", "زيت الدفرنس")],
    ] },
    { key: "chassis", label: L("Onderstel", "Chassis", "الهيكل"), items: [
      ["air_susp", L("Luchtvering / balgen", "Air suspension / bellows", "التعليق الهوائي")],
      ["leaf_springs", L("Bladveren", "Leaf springs", "السوست")],
      ["steering", L("Stuurinrichting", "Steering", "الدركسيون")],
      ["fifth_wheel", L("Koppelschotel", "Fifth wheel", "صحن القطر")],
      ["frame", L("Chassis / bevestigingen", "Frame / mounts", "الشاصي")],
    ] },
    { key: "engine", label: L("Motor / elektrisch", "Engine / electrical", "المحرك / الكهرباء"), items: [
      ["batteries", L("Accu's", "Batteries", "البطاريات")],
      ["belts", L("Riemen", "Belts", "السيور")],
      ["obd", L("Foutcodes", "Fault codes", "أكواد الأعطال")],
      ["tacho", L("Tachograaf", "Tachograph", "التاكوغراف")],
      ["air_filter", L("Luchtfilter", "Air filter", "فلتر الهواء")],
    ] },
    { key: "cabin", label: L("Cabine", "Cabin", "الكابينة"), items: [
      ["wipers", L("Ruitenwissers / sproeiers", "Wipers / jets", "المساحات")],
      ["windscreen", L("Voorruit (sterretje / barst)", "Windscreen", "الزجاج الأمامي")],
      ["mirrors", L("Spiegels / camera's", "Mirrors / cameras", "المرايا")],
      ["horn", L("Claxon", "Horn", "البوري")],
      ["dash_warnings", L("Waarschuwingslampjes dashboard", "Dashboard warning lights", "لمبات التحذير")],
      ["ac", L("Airco / standkachel", "A/C / parking heater", "المكيف / التدفئة")],
      ["seatbelts", L("Gordels / stoelen", "Seat belts / seats", "أحزمة الأمان / المقاعد")],
    ] },
    { key: "body", label: L("Carrosserie & opbouw", "Body", "الهيكل الخارجي"), items: [
      ["body_damage", L("Schade / deuken", "Damage / dents", "الأضرار")],
      ["doors_locks", L("Deuren / sloten", "Doors / locks", "الأبواب / الأقفال")],
      ["mudguards", L("Spatborden / spatlappen", "Mudguards / flaps", "رفارف الطين")],
      ["underrun", L("Zij- / onderrijbeveiliging", "Side / underrun protection", "حماية الاصطدام")],
    ] },
    { key: "safety", label: L("Veiligheid & keuring", "Safety & inspection", "السلامة والفحص"), items: [
      ["extinguisher", L("Brandblusser (keuringsdatum)", "Fire extinguisher", "طفاية الحريق")],
      ["triangle_vest", L("Gevarendriehoek / vest / verbandkist", "Triangle / vest / first aid", "مثلث / سترة / إسعاف")],
      ["wheel_chocks", L("Wielkeggen", "Wheel chocks", "موانع العجلات")],
      ["tacho_cal", L("Tachograaf-ijking", "Tachograph calibration", "معايرة التاكوغراف")],
      ["inspection_due", L("Keuring vervaldatum", "Inspection due date", "تاريخ الفحص")],
    ] },
  ],
  trailer: [
    { key: "tyres", label: L("Banden per as", "Tyres per axle", "الإطارات لكل محور"), items: axles(3) },
    { key: "brakes", label: L("Remmen", "Brakes", "الفرامل"), items: [
      ["brake_lining", L("Remvoering", "Brake lining", "فحمات الفرامل")],
      ["brake_discs", L("Schijven / trommels", "Discs / drums", "الأقراص / الطنابر")],
      ["brake_chambers", L("Remcilinders", "Brake chambers", "أسطوانات الفرامل")],
      ["air_lines", L("Luchtleidingen / koppelingen", "Air lines / couplings", "خطوط الهواء")],
      ["ebs", L("EBS / ABS", "EBS / ABS", "EBS / ABS")],
      ["park_brake", L("Parkeerrem", "Parking brake", "فرامل الوقوف")],
    ] },
    { key: "lights", label: L("Verlichting / elektrisch", "Lights / electrical", "الإضاءة / الكهرباء"), items: [
      ["light_rear", L("Achterlichten", "Rear lights", "المصابيح الخلفية")],
      ["light_brake", L("Remlichten", "Brake lights", "أضواء الفرامل")],
      ["light_turn", L("Knipperlichten", "Indicators", "الغمازات")],
      ["light_marker", L("Zijmarkering / contour", "Side markers", "الإضاءة الجانبية")],
      ["light_plate", L("Kentekenverlichting", "Plate light", "إضاءة اللوحة")],
      ["plugs", L("Stekkers 7/15-polig", "7/15-pin plugs", "الفيش")],
    ] },
    { key: "chassis", label: L("Onderstel", "Chassis", "الهيكل"), items: [
      ["air_susp", L("Luchtvering / balgen", "Air suspension", "التعليق الهوائي")],
      ["axles_bearings", L("Assen / lagers", "Axles / bearings", "المحاور / الرمان بلي")],
      ["king_pin", L("King pin", "King pin", "King pin")],
      ["landing_gear", L("Steunpoten", "Landing gear", "أرجل الدعم")],
      ["underrun", L("Onderrijbeveiliging", "Underrun protection", "حماية الاصطدام")],
    ] },
    { key: "body", label: L("Opbouw", "Body", "الصندوق"), items: [
      ["floor", L("Vloer", "Floor", "الأرضية")],
      ["walls", L("Zeil / wanden", "Curtain / walls", "الجوانب")],
      ["doors", L("Deuren / sluitingen", "Doors / locks", "الأبواب / الأقفال")],
      ["twist_locks", L("Twistlocks / vergrendeling", "Twist locks", "أقفال الحاوية")],
      ["reflectors", L("Reflectoren / markering", "Reflectors", "العواكس")],
      ["inspection_due", L("Keuring", "Inspection due", "الفحص الدوري")],
    ] },
  ],
};

export const STATUS_ORDER = ["ok", "attention", "replace"];
export const labelOf = (obj, lang) => obj[lang] || obj.nl;
